import { Link, useHistory } from 'react-router-dom';

export const LinkEcommerceLogin = () => {
  const history = useHistory();
  const to = `/login${history.location.search}`;

  return <Link to={to}>login</Link>;
};
